/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-prototype-builtins */
import React, { useEffect, useLayoutEffect, useState } from 'react'
import { FileText, Clock, XCircle, RefreshCcw, XOctagon } from 'react-feather'
import { useLocation, useNavigate } from 'react-router-dom'
import { Avatar, Box, Divider, Text, Button, useDisclosure, Flex, Skeleton, Spinner, useToast, Link, HStack } from '@chakra-ui/react'
import { ToastComponent } from '@wow/toast'
import { AlertComponent, AlertDescription, AlertTitle } from '@wow/alert'
import ResendEmailCollaboratorsPage from 'views/ResendEmailCollaboratorsPage'

import { capitalize, pluralize } from 'utils/functions/formatString'
import { useGlobalContext } from 'providers/GlobalProvider'
import IBStep from 'components/common/IBStepper/IBStep'
import IBStepper from 'components/common/IBStepper/IBStepper'
import CollaboratorsResume from 'components/Dashboard/CollaboratorsResume'
import CompanyResume from 'components/Dashboard/CompanyResume'
import PlanResume from 'components/Dashboard/PlanResume'
import getAvatar from 'components/BankAccordion/bankAvatar'
import CardTop from 'components/Dashboard/CardSectionTop/CardTop'
import IBModalAction from 'components/common/IBModalAction/IBModalAction'
import IBalert from 'components/common/IBalert/IBalert'
import { postSuscriptionDocuments, postCancelSubscription, postCollaboratorReConfirmation, getDashboard, getApplicationKeys, postSubscription, postSuscriptionStatusBanks } from 'services/api'
import CardLeft from 'components/Dashboard/CardSectionTop/CardLeft'
import bank from 'assets/images/bank.svg'
import { isSuccessStatus } from 'utils/functions/validations'

import { IDashboardBanks, IFetchedGetDashborad, IGetDashborad, IPostSubscription, IStatusBanks, ResponseIStatusBanks } from 'services/IApi.d'
import IBModalWelcome from 'components/common/IBModalAction/IBModalWelcome'
import useGa from 'hooks/ga/useGa'
import { IAlertErrorCollab, IMessageAlertExpired, IMessageCardScenario, IStepLabel } from './DashboardPage.d'


const styleBox = {
  bg: '#F6EFFF',
  boxShadow: '-6px -4px 6px rgba(222, 227, 237, 0.2), 2px 2px 4px rgba(222, 227, 237, 0.25), 4px 4px 8px rgba(222, 227, 237, 0.6)',
  borderRadius: '12px',
  marginBottom: '30px',
  minHeight: '128px',
  justifyContent: 'space-between',
  padding: '27px',
  alignItems: 'center',
}

const styleBoxTwo = {
  ...styleBox,
  flexShrink: '0',
  flexGrow: '1',
  minH: '88px'
}

const styleTextBold = {
  fontWeight: 'bold',
  fontSize: '18px'
}

const textButton = {
  company: 'Cargar datos',
  plan: 'Elegir plan y cuentas',
  collaborators: 'Agregar colaboradores',
}

const title = {
  company: {
    empty: 'Cargá los datos de tu empresa',
    filled: 'Datos de tu empresa',
  },
  plan: {
    empty: 'Elegí tu plan y cuentas',
    filled: 'Tu plan y cuentas',
  },
  collaborators: {
    empty: 'Asigná colaboradores',
    filled: 'Colaboradores que asignaste',
  },
}

const description = {
  company: 'Ingresá algunos datos de tu empresa, como la razón social y CUIT.',
  plan: 'Seleccioná el plan que más se adapta a tu empresa y las cuentas con las que vas a operar en Interbanking.',
  collaborators: 'Agregá representantes legales o personas apoderadas responsables de la solicitud y quienes administrarán nuestra plataforma.',
}

const redirectSib = process.env.REACT_APP_REDIRECT_URL_SIB

const BanksAdditional = ({ banks }: any) => (
  <div>
    <div style={{ overflowY: banks.length > 2 ? 'scroll' : 'visible', maxHeight: banks.length > 2 ? '200px' : 'auto' }}>
      {banks.map(({ name: nombreBanco }) => (
        <div style={{ marginRight: '16px' }}>
          <Flex my={6} alignItems='center' boxShadow='0px 1px 3px rgb(0 0 0 / 30%)' borderRadius='12px' border='1px solid #f6f6f6'>
            <Avatar name={nombreBanco} src={getAvatar(nombreBanco)} m={3} size='sm' />
            <Text ml={2} fontSize='16px' fontWeight='700'>{capitalize(nombreBanco)}</Text>
          </Flex>
        </div>
      ))}
    </div>
    <Divider variant='solid' color='#BEC6DC' borderWidth={1} mt={6} mb={6} />
    <Flex textAlign='left' >
      <Text as='h6' fontSize='18px' fontFamily='var(--chakra-fonts-headingBold)'>Suscripción digital (documentos opcionales)</Text>
    </Flex>
    <Box textAlign='left' mt={3}>
      <Text as='b'>
        El resto de tus bancos responderán a tu solicitud de manera digital y no tienen una etapa presencial.
      </Text>
      {' '}
      Si preferís finalizar un alta digital en una sucursal, podés obtener los documentos en la{' '}
      <Link color='blue.500' href={redirectSib}>plataforma</Link>.
      <br /><br />
      Una vez que ingreses, hacé clic en Suscripción, luego seleccioná
      <br />Offering y finalmente Servicios contratados para descargar los
      <br />documentos.
    </Box>
    <Divider variant='solid' color='#BEC6DC' borderWidth={1} mt={6} mb={3} />
  </div>
)

export const DASHBOARD_STATUS = {
  initial: null, // steps 1, 2 or 3 incomplete
  pendingCollaborators: 'PENDIENTE_CONFIRMACION', // email to RL and Admin sended
  expired: 'EXPIRADO', // one or more RL did not confirm the request
  sending: 'PENDIENTE_ENVIO', // sending subscription to banks
  sendingError: 'ERROR_ENVIO', // subscription can not be sending by an error
  pendingBanks: 'PENDIENTE_CONFIRMACION_BANCOS', // one or more banks did not confirm yet
  finalized: 'FINALIZADO', // subscription finalized 
}


export const COLABORATOR_STATUS = {
  created: 'CREATED', // email to colaborator sended
  expired: 'EXPIRED', // email to colaborator expired
  sending: 'SUCCESS', // email to colaborator confirm
  sendingError: 'FAIL', // email to colaborator can not be sending by an error
}

const DashboardPage = () => {
    const navigate = useNavigate()
  const location = useLocation()
  const { sendDataLayer } = useGa()
  const [loading, setLoading] = useState<boolean>(false)
  const [loadingDocument, setLoadingDocument] = useState<string>('')
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [onErrorMail, setOnErrorMail] = useState<boolean>(false)
  const [modalNewCompany, setModalNewCompany] = useState<boolean>(false)
  const [isSubscriptionFail, setIsSubscriptionFail] = useState<boolean>(false)
  const [isCollaboratorFail, setIsCollaboratorFail] = useState<boolean>(false)
  const [isCollaboratorExpired, setIsCollaboratorExpired] = useState<boolean>(false)
  const [isLoadindResendEmail, setIsLoadindResendEmail] = useState<boolean>(false)
  const [isLoadindResendEmailExpired, setIsLoadindResendEmailExpired] = useState<boolean>(false)

  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isOpenError, onOpen: onOpenError, onClose: onCloseError } = useDisclosure()
  const { isOpen: isOpenAlert, onOpen: onOpenAlert, onClose: onCloseAlert } = useDisclosure()
  const { isOpen: isOpenAlertReSend, onOpen: onOpenAlertReSend, onClose: onCloseAlertReSend } = useDisclosure()
  const { isOpen: isOpenSuccessSib, onOpen: onOpenSuccessSib, onClose: onCloseSuccessSib } = useDisclosure()

  const { isOpen: isOpenCancelConfirmation, onOpen: onOpenCancelConfirmation, onClose: onCloseCancelConfirmation } = useDisclosure()
  const { isOpen: isOpenConfirmationPending, onOpen: onOpenConfirmationPending, onClose: onCloseConfirmationPending } = useDisclosure()

  const [data, setData] = useState<IGetDashborad>(null)
  const [subscriptionStatusBanks, setSubscriptionStatusBanks] = useState<IStatusBanks>(null)
  const [checkingStatus, setCheckingStatus] = useState<boolean>(false)
  const [hasCard, setHasCard] = useState<boolean>(false)

  const { headerInfo, setHeaderInfo, setIsRequestSent, isRequestSent, idSuscriptor, idEmpresa, resetStates, setCuit, setCompanyName, setCompanyQuantity } = useGlobalContext()

  const isIncompleteDashboard: boolean = data?.subscriptionStatus === DASHBOARD_STATUS.initial
  const isConfirmationPendient: boolean = data?.subscriptionStatus === DASHBOARD_STATUS.pendingCollaborators
  const isSendingSubscription: boolean = data?.subscriptionStatus === DASHBOARD_STATUS.sending
  const isFailedSubscription: boolean = data?.subscriptionStatus === DASHBOARD_STATUS.sendingError
  const isConfirmationPendientBank: boolean = data?.subscriptionStatus === DASHBOARD_STATUS.pendingBanks
  const isExpired: boolean = data?.subscriptionStatus === DASHBOARD_STATUS.expired
  const isFinalized: boolean = data?.subscriptionStatus === DASHBOARD_STATUS.finalized
  const textIsExpired: string = isExpired ? 'Reenviar' : 'Enviar'

  const isDigSubscription: boolean = data?.subscriptionType === 'DIGITAL'
  const isPhysicSubscription: boolean = data?.subscriptionType === 'FISICA'

  const startedRevisionBanks: boolean = subscriptionStatusBanks && (+subscriptionStatusBanks.approved !== 0 || +subscriptionStatusBanks.rejected !== 0)
  const hasApprovedBanks: boolean = subscriptionStatusBanks && +subscriptionStatusBanks.approved > 0
  const hasTotalApprovedBank: boolean = subscriptionStatusBanks && +subscriptionStatusBanks.pending === 0

  const hasRepresentativesLegal: boolean = data?.collaborators?.some((item: any) => item?.role?.includes(2))
  const hasAdministrators: boolean = data?.collaborators?.some((item: any) => item?.role?.includes(1))
  const toast = useToast()
  const openToast = () => {
    toast({
      duration: 7000,
      position: 'bottom-left',
      status: 'error',
      description: 'No podemos descargar los documentos. Volvé a intentarlo.',
      render: props => (
        <ToastComponent {...props} />
      ),
    })
  }

  const openToastEmail = () => {
    toast({
      duration: 7000,
      position: 'bottom-left',
      status: 'success',
      description: 'Reenviamos el email con éxito. Tiene una validez de 72 horas.',
      render: (props) => (
        <ToastComponent {...props} />
      ),
    })
  }

  const defineScenario = () => {
    if (isDigSubscription && !hasRepresentativesLegal) {
      return '7'
    }
    if (isPhysicSubscription && hasRepresentativesLegal) {
      return '6'
    }
    if (isPhysicSubscription) {
      return '4'
    }
    if (isExpired) {
      return '5'
    }
    return data?.scenery
  }
  const scenario = defineScenario()
  
  const pendingRequestConfirmation = data?.collaborators?.filter(item => item.confirmed === DASHBOARD_STATUS.pendingCollaborators && (item.role.includes(2) || (item.role.includes(1) && item.role.includes(2)))).length

  const pluralizeSolicitudNumber = pendingRequestConfirmation > 1 ? 'confirmaciones' : 'confirmación'
  const pluralizeSolicitudString = pendingRequestConfirmation > 1 ? 'pendientes' : 'pendiente'

  const banksRemaining = data?.plan?.banks?.filter((banco: IDashboardBanks) => !banco.isDigitalSubscription)

  const banksRemainingLength = banksRemaining?.length

  const physicBanksQuantity = data?.plan?.physicalSubscriptionsQuantity

  const banksRemainingMessage = `${banksRemainingLength} de tus bancos ${banksRemainingLength > 1 ? 'necesitan' : 'necesita'} que descargues y presentes la solicitud física firmada por los representantes legales o personas apoderadas que asignaste.`

  const hasCompany = data?.status?.company === 'FILLED'
  const hasCollaborators = data?.status?.collaborators === 'FILLED'
  const hasPlan = data?.status?.plans === 'FILLED'

  const firstStep = !hasPlan && !hasCollaborators
  const firstStepLabels: IStepLabel = {
    title: 'Hola',
    subtitle: 'Completá las tareas para iniciar la solicitud a los bancos y comenzar a operar.'
  }

  const secondStep = hasPlan && !hasCollaborators
  const secondStepLabels: IStepLabel = {
    title: 'Bien',
    subtitle: 'Asigná colaboradores a tu cuenta de Interbanking.'
  }

  const thirdStep = hasPlan && hasCollaborators
  const thirdStepLabels: IStepLabel = {
    title: 'Bien',
    subtitle: 'Estás cerca de terminar todas tus tareas.'
  }

  const fourStepLabels: IStepLabel = {
    title: '',
    subtitle: '¡Tenemos buenas noticias para vos!'
  }

  const alertErrorPostSendCollaborators: IAlertErrorCollab = {
    text: 'Por favor intentá nuevamente.',
    variant: 'linkError',
    title: 'Tenemos algunos inconvenientes técnicos'
  }

  const isPendient = isConfirmationPendient || isConfirmationPendientBank 
  const isFail = isExpired || isFailedSubscription 
  const isSent = isPendient || isFail || isSendingSubscription || isFinalized

  const linkLogin = () => {
    window.open(process.env.REACT_APP_REDIRECT_URL_SIB, '_blank')
  }

  const handleCancelSubscription = async () => {
    const response = await postCancelSubscription(idSuscriptor, idEmpresa)
    if (isSuccessStatus(response?.status)) {
      onCloseCancelConfirmation()
      setCompanyQuantity(prev => prev - 1)
      navigate('/dashboard', { state: 'dashboardNew' })
    }
  }

  const isDisabledButtonNewCompany = (): boolean => data?.status?.company === 'EMPTY'

  const openModal = async () => {
    sendDataLayer({
      event: 'select_content',
      content_group: 'Onboarding',
      content_type: 'CTAs pantalla de tareas',
      item_id: 'Suscribir otra empresa'
    })
    const { data: { quantity } } = await getApplicationKeys()
    if (quantity > 1) {
      navigate('/dashboard', { state: 'dashboardNew' })
    } else {
      setModalNewCompany(true)
    }
  }

  const closeModal = () => {
    setModalNewCompany(false)
  }

  const redirectNewCompany = () => {
    navigate('/dashboard', { state: 'dashboardNew' })
    setModalNewCompany(false)
  }

  const handleDocumentsDownload = async value => {
    setLoadingDocument(value)
    const response = await postSuscriptionDocuments(idSuscriptor, idEmpresa)
    if (isSuccessStatus(response?.status)) {
      setLoadingDocument('')
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'file.zip')
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(link)
    } else {
      onCloseConfirmationPending()
      setLoadingDocument('')
      openToast()
    }
  }

  const getDashboardStatusForConsulting = async () => {
    const response: IFetchedGetDashborad = await getDashboard(idSuscriptor, idEmpresa)
    if (!isSuccessStatus(response?.status)) {
      navigate('/error')
      return null
    }
    setIsCollaboratorFail(response?.data?.collaboratorStatus === COLABORATOR_STATUS.sendingError)
    setIsCollaboratorExpired(response?.data?.collaboratorStatus === COLABORATOR_STATUS.expired)

    return response?.data
  }

  const checkStatus = () => {
    setCheckingStatus(true)
    getDashboardStatusForConsulting()
    .then(result => {
      setData(result)
      setHasCard(!!result?.scenery)
    })
    .then(() => setCheckingStatus(false))
  }

  const resendSubscription = () => {
    setCheckingStatus(true)
    postSubscription(idSuscriptor, idEmpresa)
      .then((response: IPostSubscription) => {
        if (!isSuccessStatus(response.status)) {
          setCheckingStatus(false)
          setIsSubscriptionFail(true)
        } else {
          setCheckingStatus(false)
          navigate('/dashboard')
        }
      })
  }

  useLayoutEffect(() => {
    if (!idSuscriptor) return
    if (location.state !== 'dashboardNew') {
      const getDashboardStatus = async () => {
        const response: IFetchedGetDashborad = await getDashboard(idSuscriptor, idEmpresa)
        if (!isSuccessStatus(response?.status)) {
          navigate('/error')
          return null
        }
        if (response?.data?.status?.company === 'EMPTY') {
          sendDataLayer({
            event: 'login',
            user_id: idSuscriptor,
          })
        }
        const cuitClean = response?.data?.company?.document?.number.replace(/-/g, '')
        setCuit(cuitClean)
        setCompanyName(response?.data?.company?.name)
        setIsLoaded(true)
        setIsCollaboratorFail(response?.data?.collaboratorStatus === COLABORATOR_STATUS.sendingError)
        setIsCollaboratorExpired(response?.data?.collaboratorStatus === COLABORATOR_STATUS.expired)

        setIsRequestSent(response?.data?.subscriptionStatus !== DASHBOARD_STATUS.initial)
        return response?.data
      }

      const postSubscriptionStatusBanks = async (): Promise<ResponseIStatusBanks> => {
        const response: ResponseIStatusBanks = await postSuscriptionStatusBanks(idSuscriptor, idEmpresa)
        return response
      }

      getDashboardStatus().then(setData)

      postSubscriptionStatusBanks().then(response => {       
        if (response.status === 200 || response.status === 201) {
          setSubscriptionStatusBanks(response.data)
        } else {
          setSubscriptionStatusBanks(null)
        }        
      }).catch(() => { 
        setSubscriptionStatusBanks(null)
      })
    } else {
      resetStates()
      setData({
        status: {
          company: 'EMPTY',
          plans: 'BLOCKED',
          collaborators: 'BLOCKED'
        },
        company: {
          name: null,
          document: null
        },
        plan: {
          name: null,
          services: null,
          additionalServices: null,
          type: null,
          price: null,
          physicalSubscriptionsQuantity: null,
          banks: null
        },
        collaborators: [],
        subscriptionType: null,
        subscriptionStatus: null,
        collaboratorStatus: null,
        scenery: null
      })
      setIsCollaboratorFail(false)
      setIsCollaboratorExpired(false)
      closeModal()
    }
  }, [idSuscriptor, location])

  useEffect(() => {
    if ((isPhysicSubscription && hasRepresentativesLegal) || (isDigSubscription && !hasRepresentativesLegal && hasCollaborators)) {
      onOpen()
    }

    let headerLabels = {}
    if (isExpired) {
      onOpen()
    }

    if (firstStep) {
      headerLabels = firstStepLabels
    }

    if (secondStep) {
      headerLabels = secondStepLabels
    }

    if (thirdStep) {
      headerLabels = thirdStepLabels
    }

    if (isConfirmationPendientBank) {
      headerLabels = fourStepLabels
    }

    setHeaderInfo(() => ({
      ...headerInfo,
      ...headerLabels
    }))

    return () => {
      setHeaderInfo({
        title: '',
        subtitle: ''
      })
    }
  }, [data])

  useEffect(() => {
    if (location.state && location.state === 'mailSended' && !isFailedSubscription && !isIncompleteDashboard) {
      onOpenAlert()
    }
    if (location.state && location.state === 'mailReSended') {
      onOpenAlertReSend()
    }
    if (location.state && location.state === 'successSibuser') {
      onOpenSuccessSib()
    }
  }, [location])

  const messageAlertExpired: IMessageAlertExpired = {
    title: '¡Listo! Reenviaste la solicitud con éxito',
    body: 'Cuando la confirmación esté lista, la mandaremos a tus bancos para su revisión.',
  }

  const messageCard: IMessageCardScenario = {
    '1': { // if exist a RL
      // TODO REVIEW THIS SCENARIO TEXTS
      title: 'Enviá la solicitud',
      subTitle: 'Representantes legales y personas apoderadas deberán confirmarla. Si cumplís alguno de esos roles también tendrás que hacerlo. Tené en cuenta que una vez enviada la información, no podrás modificarla.',
      modal: {
        title: 'Estás por enviar la solicitud',
        bodyModal: 'Tus representantes legales / personas apoderadas deberán confirmarla por email y los bancos también tendrán que aprobarla. Una vez enviada, no podrás modificarla.',
        footerModal: {
          cancel: 'Cancelar',
          sendDataText: 'Enviar',
          sendData: async () => {
            setLoading(true)
            const subscriptionResponse = await postSubscription(idSuscriptor, idEmpresa)
            const isSuccessSubscription = isSuccessStatus(subscriptionResponse?.status)

            setLoading(false)

            if (isSuccessSubscription) {
              sendDataLayer({
                event: 'completed_onboarding_step',
                onboarding_step: 'Solicitud enviada a bancos',
                plan: data?.plan?.name
              })
              setLoading(false)
              if (isDigSubscription) {
                onClose()
                setIsRequestSent(true)
                navigate('/dashboard', { state: 'mailSended' })
              } else {
                onClose()
                setIsRequestSent(true)
                navigate('/dashboard', { state: 'mailSended' })
                onOpenAlert()
              }
            } else {
              setIsSubscriptionFail(true)
              onClose()
            }
          }
        }
      },
      // TODO REVIEW THIS SCENARIO TEXTS
      alert: {
        title: 'La solicitud ya está en los bancos',
        body: 'Para que pueda ser aprobada, tus representantes deberán confirmarla primero. Te avisaremos cuando los bancos nos notifiquen su respuesta.',
      }
    },
    '2': { // subscriptor is not a RL
      // TODO REVIEW THIS SCENARIO TEXTS
      title: 'Enviá la solicitud',
      subTitle: 'Representantes legales y personas apoderadas deberán confirmarla. Si cumplís alguno de esos roles también tendrás que hacerlo. Tené en cuenta que una vez enviada la información, no podrás modificarla.',
      modal: {
        title: 'Estás por enviar la solicitud',
        bodyModal: 'Tus representantes legales / personas apoderadas deberán confirmarla por email y los bancos también tendrán que aprobarla. Una vez enviada, no podrás modificarla.',
        footerModal: {
          cancel: 'Cancelar',
          sendDataText: 'Enviar',
          sendData: async () => {
            setLoading(true)
            const [subscriptionResponse] = await Promise.all([postSubscription(idSuscriptor, idEmpresa)])
            const isSuccessSubscription = isSuccessStatus(subscriptionResponse?.status)
            setLoading(false)

            if (isSuccessSubscription) {
              sendDataLayer({
                event: 'completed_onboarding_step',
                onboarding_step: 'Solicitud enviada a bancos',
                plan: data?.plan?.name
              })
              onClose()
              setIsRequestSent(true)
              navigate('/dashboard', { state: 'mailSended' })
            } else {
              setIsSubscriptionFail(true)
              onClose()
            }
          }
        }
      },
      // TODO REVIEW THIS SCENARIO TEXTS
      alert: {
        title: 'La solicitud ya está en los bancos',
        body: 'Para que pueda ser aprobada, tus representantes deberán confirmarla primero. Te avisaremos cuando los bancos nos notifiquen su respuesta.',
      }
    },
    '3': { // When subscriptor is RL
      // TODO REVIEW THIS SCENARIO TEXTS
      title: 'Enviá la solicitud',
      subTitle: 'Representantes legales y personas apoderadas deberán confirmarla. Si cumplís alguno de esos roles también tendrás que hacerlo. Tené en cuenta que una vez enviada la información, no podrás modificarla.',
      modal: {
        title: 'Estás por enviar la solicitud',
        bodyModal: 'Tus representantes legales / personas apoderadas deberán confirmarla por email y los bancos también tendrán que aprobarla. Una vez enviada, no podrás modificarla.',
        footerModal: {
          cancel: 'Cancelar',
          sendDataText: 'Enviar',
          sendData: async () => {
            setLoading(true)
            const subscriptionResponse = await postSubscription(idSuscriptor, idEmpresa)
            const isSuccessSubscription = isSuccessStatus(subscriptionResponse?.status)

            setLoading(false)
            if (isSuccessSubscription) {
              sendDataLayer({
                event: 'completed_onboarding_step',
                onboarding_step: 'Solicitud enviada a bancos',
                plan: data?.plan?.name
              })
              onClose()
              setIsRequestSent(true)
              navigate('/dashboard', { state: 'mailSended' })
            } else {
              setIsSubscriptionFail(true)
              onClose()
            }
          }
        }
      },
      // TODO REVIEW THIS SCENARIO TEXTS
      alert: {
        title: 'La solicitud ya está en los bancos',
        body: 'Para que pueda ser aprobada, tus representantes deberán confirmarla primero. Te avisaremos cuando los bancos nos notifiquen su respuesta.',
      }
    },
    '4': { // Física
      title: 'Cuando la solicitud esté lista, enviala a los bancos para su aprobación',
      subTitle: '',
      modal: {
        title: 'Estás por enviar la solicitud',
        bodyModal: 'La revisarán antes de darte una respuesta.',
        footerModal: {
          cancel: 'Cancelar',
          sendDataText: 'Enviar',
          sendData: async () => {
            setLoading(true)
            const subscriptionResponse = await postSubscription(idSuscriptor, idEmpresa)
            const isSuccess = isSuccessStatus(subscriptionResponse?.status)
            setLoading(false)

            if (isSuccess) {
              sendDataLayer({
                event: 'completed_onboarding_step',
                onboarding_step: 'Solicitud enviada a bancos',
                plan: data?.plan?.name
              })
              onClose()
              setIsRequestSent(true)
              navigate('/dashboard', { state: 'mailSended' })
            } else {
              setIsSubscriptionFail(true)
              onClose()
            }
          }
        }
      },
      alert: {
        title: 'La solicitud ya está en los bancos',
        body: 'Te avisaremos cuando nos notifiquen su respuesta.',
      }
    },
    '5': {
      title: 'La invitación para confirmar la solicitud expiró',
      subTitle: '',
      modal: {
        title: 'La invitación para confirmar expiró',
        bodyModal: 'Reenviá la solicitud por mail nuevamente para que se confirme dentro de las siguientes 24 horas.',
        footerModal: {
          cancel: '',
          sendDataText: 'Reenviar solicitud',
          sendData: async () => {
            setLoading(true)
            const response = await postCollaboratorReConfirmation(idSuscriptor, idEmpresa)
            if (isSuccessStatus(response?.status)) {
              setLoading(false)
              onClose()
              setIsRequestSent(true)
              navigate('/dashboard', { state: 'mailReSended' })
            } else {
              onClose()
              onOpenError()
              setLoading(false)
            }
          }
        }
      },
      alert: {
        title: '¡Listo! Reenviaste la solicitud con éxito',
        body: 'Cuando la confirmación esté lista, la mandaremos a tus bancos para su revisión.',
      }
    },
    '6': {
      modal: {
        title: 'Necesitás hacer cambios en tus colaboradores',
        bodyModal: 'La modificación que hiciste en tu lista de bancos lo requiere',
        footerModal: {
          cancel: '',
          sendDataText: 'Entendido',
          sendData: async () => {
            setLoading(true)
            onClose()
          }
        }
      },
      alert: {
        title: 'Eliminá representantes legales o personas apoderadas de tus colaboradores',
        body: 'La modificación que hiciste en tu lista de bancos lo requiere.',
      }
    },
    '7': {
      modal: {
        title: 'Necesitás hacer cambios en tus colaboradores',
        bodyModal: 'La modificación que hiciste en tu lista de bancos lo requiere',
        footerModal: {
          cancel: '',
          sendDataText: 'Entendido',
          sendData: async () => {
            setLoading(true)
            onClose()
          }
        }
      },
      alert: {
        title: 'Agregá representantes legales o personas apoderadas como colaboradores',
        body: 'La modificación que hiciste en tu lista de bancos lo requiere.',
      }
    }
  }

  const clickCancel = () => {
    sendDataLayer({
      event: 'select_content',
      content_group: 'Onboarding',
      content_type: 'CTAs pantalla de tareas',
      item_id: 'Cancelar solicitud'
    })
    onOpenCancelConfirmation()
  }

  const resendEmailCollaborators = async () => {
    const response = await postCollaboratorReConfirmation(idSuscriptor, idEmpresa)
    if (isSuccessStatus(response?.status)) {
      setIsRequestSent(true)
      setIsCollaboratorFail(false)
      setIsCollaboratorExpired(false)
      setTimeout(()=>{
        setIsLoadindResendEmail(false)
        setIsLoadindResendEmailExpired(false)
        openToastEmail()
      },5000)
    } else {
      setTimeout(()=>{
        setIsLoadindResendEmail(false)
        setIsLoadindResendEmailExpired(false)
        setOnErrorMail(true)
      },5000)
    }
  }

  return (
    <Box> {
      isLoadindResendEmail ? <ResendEmailCollaboratorsPage title='Reenviando el email a tus colaboradores' description='Esto puede demorar unos instantes.' />
        :
        isLoadindResendEmailExpired ? <ResendEmailCollaboratorsPage title='Reenviando el email a tus colaboradores' description='Solo lo enviaremos a las personas que todavía no hayan confirmado.'/>
        :
        <>
          {
            hasRepresentativesLegal
            && !isPhysicSubscription
            && hasCollaborators
            && !isConfirmationPendient
            && !isConfirmationPendientBank
            && !isExpired
            && !isSendingSubscription
            && !isFailedSubscription
            && !isSubscriptionFail
            && !isFinalized
            &&
            <CardTop
              title={messageCard[scenario]?.title}
              subTitle={messageCard[scenario]?.subTitle}
              textButton='Enviar solicitud'
              onOpen={onOpen}
            />
          }
          <> 
          { isCollaboratorFail &&
          <Box mb='4' mt={-8} >
              <AlertComponent
                id="alert-id"
                variant="destructive"
                onClose={() => setIsCollaboratorFail(false)}
                buttonLabel="Reenviar"
                onClick={() => {
                  setIsLoadindResendEmail(true)
                  resendEmailCollaborators()
                }}
              >
                <AlertTitle>No pudimos enviar el email a tus colaboradores</AlertTitle>
                <AlertDescription>
                  Es importante que lo confirmen para que puedas completar el proceso. Volvé a enviarlo.
                </AlertDescription>
              </AlertComponent>
            </Box> 
              }
          { isCollaboratorExpired &&
          <Box mb='4' mt={-8} >
              <AlertComponent
                id="alert-id"
                variant="warning"
                onClose={() => setIsCollaboratorExpired(false)}
                buttonLabel="Reenviar"
                onClick={() => {
                  setIsLoadindResendEmailExpired(true)
                  resendEmailCollaborators()
                }}
              >
                <AlertTitle>El email que enviamos a tus colaboradores venció</AlertTitle>
                <AlertDescription>
                  Es importante que lo confirmen para que puedas completar el proceso. Volvé a enviarlo.
                </AlertDescription>
              </AlertComponent>
            </Box> 
              }
              {
            (isConfirmationPendient || (isPhysicSubscription && hasAdministrators) || (isDigSubscription && !hasRepresentativesLegal && hasCard) || isConfirmationPendientBank || isExpired || isSendingSubscription || isFailedSubscription || isSubscriptionFail || isFinalized) &&
            <Flex>
              {(subscriptionStatusBanks && isRequestSent && isConfirmationPendientBank && startedRevisionBanks) || isFinalized
                ? <CardLeft icon={isConfirmationPendientBank && <img src={bank} />} >
                  <Flex flexShrink='0' flexGrow='1' justifyContent='space-between' alignItems='center'>
                    <Box>
                      <Text borderBottom='1px solid' borderBottomColor='grey.30'>
                        {
                          hasTotalApprovedBank ? '¡La revisión de la solicitud finalizó!' : 'La solicitud continúa en revisión'
                        }
                      </Text>
                      <HStack justifyContent='space-between'>
                        <Flex alignItems='center'>
                          {subscriptionStatusBanks?.pending} <Text textStyle='bodyMd' ml={1}>Pendientes</Text>
                        </Flex>
                        <Flex alignItems='center'>
                          {subscriptionStatusBanks?.rejected} <Text textStyle='bodyMd' ml={1}>Rechazados</Text>
                        </Flex>
                        <Flex alignItems='center'>
                          {subscriptionStatusBanks?.approved} <Text textStyle='bodyMd' ml={1}>Aprobados</Text>
                        </Flex>
                      </HStack>
                    </Box>
                    <Box>
                      <Text>
                        {
                          startedRevisionBanks && <Button onClick={linkLogin} variant='link'>Ver respuestas</Button>
                        }
                        <Button marginLeft={10} disabled={!hasApprovedBanks} onClick={linkLogin}>Ir a Interbanking</Button>
                      </Text>
                    </Box>
                  </Flex>
                </CardLeft>
                :
                <CardLeft
                  icon={
                    isConfirmationPendientBank ? <img src={bank} />
                      : isExpired ? <XCircle strokeWidth={2} width='33px' height='33px' />
                        : (isPhysicSubscription || (isDigSubscription && !hasRepresentativesLegal) || checkingStatus) ? ''
                          : (isFailedSubscription || isSubscriptionFail) ? <XOctagon strokeWidth={2} width='33px' height='33px' />
                            : <Clock strokeWidth={2} width='33px' height='33px' />
                  }
                >
                  {isConfirmationPendient &&
                    <Text>
                      {pendingRequestConfirmation} {pluralizeSolicitudNumber} de solicitud {pluralizeSolicitudString}
                    </Text>
                    ||
                    (isConfirmationPendientBank && !startedRevisionBanks) &&
                    <Box>
                      <Text textStyle='h3'>{messageCard[scenario]?.alert.title}</Text>
                      <Text textStyle='bodyLd'>{messageCard[scenario]?.alert.body}</Text>
                    </Box>
                    ||
                    (isPhysicSubscription || isExpired) && !isSendingSubscription && !isFailedSubscription && !isSubscriptionFail &&
                    <Flex justifyContent='space-between' flexShrink='0' flexGrow='1' alignItems='center'>
                      <Text sx={isExpired ? {} : { maxW: '320px' }}>{messageCard[scenario]?.title}</Text>
                      <Button minW='220px' borderRadius='8px' onClick={onOpen} data-testid='send-request'>{textIsExpired} solicitud</Button>
                    </Flex>
                    || (isSendingSubscription) &&
                    <Flex direction='row' justifyContent={checkingStatus ? 'center' : 'space-between'} flexShrink='0' flexGrow='1' alignItems='center'>
                      {checkingStatus ?
                        <Spinner
                          data-testid='spinner'
                          w='48px'
                          h='48px'
                          emptyColor='primary.500'
                          color='primary.60'
                          thickness='4px'
                        />
                        :
                        <>
                          <Flex direction='column'>
                            <Text textStyle='h6'>Tu solicitud está en proceso de envío</Text>
                            <Text textStyle='bodyMd'>Cuando esté en los bancos, lo verás acá.</Text>
                          </Flex>
                          <Flex direction='column' ml={4}>
                            <Button leftIcon={<RefreshCcw />} onClick={checkStatus}>Consultar estado</Button>
                          </Flex>
                        </>
                      }
                    </Flex>
                    || (isFailedSubscription || isSubscriptionFail) &&
                    <Flex direction='row' justifyContent={checkingStatus ? 'center' : 'space-between'} flexShrink='0' flexGrow='1' alignItems='center'>
                      {checkingStatus ?
                        <Spinner
                          data-testid='spinner'
                          w='48px'
                          h='48px'
                          emptyColor='primary.500'
                          color='primary.60'
                          thickness='4px'
                        />
                        :
                        <>
                          <Flex direction='column'>
                            <Text textStyle='h6'>No podemos enviar la solicitud</Text>
                            <Text textStyle='bodyMd'>Por favor, volvé a intentarlo.</Text>
                          </Flex>
                          <Flex direction='column' ml={4}>
                            <Button leftIcon={<RefreshCcw />} onClick={resendSubscription}>Reenviar solicitud</Button>
                          </Flex>
                        </>
                      }
                    </Flex>
                  }
                </CardLeft>
              }
              {!(isPhysicSubscription && hasRepresentativesLegal) && !isDigSubscription &&
                <Flex {...styleBoxTwo} ml='12px' flex='3'>
                  <Flex>
                    <Flex {...styleTextBold}>
                      <FileText strokeWidth={2} width='33px' height='33px' />
                      {physicBanksQuantity !== '0' &&
                        <Flex pl='15px' alignItems='center' maxW='200px' fontSize='14px'>
                          {`${physicBanksQuantity} ${pluralize(Number(physicBanksQuantity), 'banco')} ${pluralize(Number(physicBanksQuantity), 'necesita', 'n')} ${pluralize(Number(physicBanksQuantity), 'documento')} ${pluralize(Number(physicBanksQuantity), 'adicional', 'es')}`}
                        </Flex>
                      }
                    </Flex>
                  </Flex>
                  <Button onClick={onOpenConfirmationPending} variant='link' data-testid='what-is-this'>¿Qué es esto?</Button>
                  <Box>
                    <Button onClick={() => handleDocumentsDownload('btnDowloand')} borderRadius='8px' isLoading={loadingDocument === 'btnDowloand'} data-testid='dowloand'>Descargar</Button>
                  </Box>
                </Flex>
              }
            </Flex>
          }
          </>
          <IBStepper>
            <Skeleton isLoaded={isLoaded}>
              <IBStep
                index={1}
                status={!isIncompleteDashboard ? '' : data?.status?.company}
                title={title.company.empty}
                filledTitle={title.company.filled}
                path={{ pathName: `/empresa/${idEmpresa || ''}` }}
                isSent={isSent}
                description={description.company}
                textButton={textButton.company}
              >
                <CompanyResume data={data?.company} />
              </IBStep>
            </Skeleton>
            <Skeleton isLoaded={isLoaded}>
              <IBStep
                index={2}
                status={!isIncompleteDashboard ? '' : data?.status?.plans} // TODO: si estadoSolicitud es != vacío status tiene que ser = "", esto parao todos los steps
                title={title.plan.empty}
                filledTitle={title.plan.filled}
                path={data?.plan?.banks?.length > 0
                  ? !isIncompleteDashboard
                    ? { pathName: '/resumen', options: { state: { edit: false } } }
                    : { pathName: '/resumen', options: { state: { edit: true } } }
                  : { pathName: '/planes' }}
                isSent={isSent}
                description={description.plan}
                textButton={textButton.plan}
              >
                <PlanResume data={data?.plan} />
              </IBStep>
            </Skeleton>
            <Skeleton isLoaded={isLoaded}>
              <IBStep
                index={3}
                status={!isIncompleteDashboard ? '' : data?.status?.collaborators}
                title={title.collaborators.empty}
                filledTitle={title.collaborators.filled}
                path={{ pathName: '/colaboradores', options: { state: { subscriptionType: data?.subscriptionType } } }}
                isSent={isSent}
                description={description.collaborators}
                textButton={textButton.collaborators}
              >
                <CollaboratorsResume data={data?.collaborators} />
              </IBStep>
            </Skeleton>
          </IBStepper>
          <Box pl='60px' sx={isConfirmationPendientBank && { pb: '90px' }}>
            <Flex justifyContent='space-between' alignItems='center' pr='24px' my={6} mb={4}>

              <Box visibility={(isIncompleteDashboard && hasCompany) || isFailedSubscription ? 'visible' : 'hidden'}>
                <Button onClick={clickCancel} variant='link' data-testid='cancel-request' color='primary.500'>Cancelar solicitud</Button>
              </Box>
              <Button
                data-testid='addCompany-button'
                w='200px'
                variant='outline'
                color='primary.500'
                borderColor='primary.500'
                disabled={isDisabledButtonNewCompany()}
                isLoading={false}
                type='submit'
                onClick={openModal}
              >
                Suscribir otra empresa
              </Button>
            </Flex>
          </Box>
          <IBModalAction
            isOpen={isOpen}
            onClose={onClose}
            buttonActionText={messageCard[scenario]?.modal?.footerModal.sendDataText}
            buttonAction={messageCard[scenario]?.modal?.footerModal.sendData}
            buttonCancel={messageCard[scenario]?.modal?.footerModal.cancel}
            title={messageCard[scenario]?.modal?.title}
            textBody={messageCard[scenario]?.modal?.bodyModal}
            isloading={loading}
          />
          <IBModalAction
            isOpen={isOpenCancelConfirmation}
            onClose={onCloseCancelConfirmation}
            buttonActionText='Sí, cancelar suscripción'
            buttonAction={handleCancelSubscription}
            buttonCancel='Volver'
            title='¿Estás por cancelar la solicitud?'
            textBody='Si lo hacés vas a perder toda la información ingresada hasta ahora.'
            isloading={loading}
          />
          <IBModalAction
            isOpen={isOpenConfirmationPending}
            onClose={onCloseConfirmationPending}
            buttonAction={() => handleDocumentsDownload('btnDowloandModal')}
            buttonActionText='Descargar'
            bodyComponent={<BanksAdditional banks={banksRemaining} />}
            title='Algunos bancos necesitan documentos adicionales'
            textBody={banksRemainingMessage}
            isloading={loadingDocument === 'btnDowloandModal'}
            buttonCancel='Cancelar'
            showBanks
          />
          <IBalert
            type='info'
            isOpen={isOpenAlert}
            onClose={onCloseAlert}
            title={messageCard[scenario]?.alert?.title}
            text={messageCard[scenario]?.alert?.body}
            variant='sm'
            buttonClose
          />
          <IBalert
            type='info'
            isOpen={isOpenAlertReSend}
            onClose={onCloseAlertReSend}
            title={messageAlertExpired?.title}
            text={messageAlertExpired?.body}
            variant='sm'
            buttonClose
          />

          {isOpenError &&
            <IBalert
              type='error'
              isOpen={isOpenError}
              onClose={onCloseError}
              title={alertErrorPostSendCollaborators.title}
              text={alertErrorPostSendCollaborators.text}
              variant={alertErrorPostSendCollaborators.variant}
              buttonClose
            />
          }
          {isOpenSuccessSib &&
            <IBalert
              type='success'
              isOpen={isOpenSuccessSib}
              onClose={onCloseSuccessSib}
              title='Completaste los datos con éxito'
              text='Ya podés agregar una nueva empresa.'
              buttonClose
            />
          }
          {modalNewCompany && (
            <IBModalWelcome
              isOpen={modalNewCompany}
              onClose={closeModal}
              title='¿Querés suscribir una nueva empresa?'
              textBody='Podés suscribir varias empresas en simultáneo sin perder la información. Desde tu perfil, cambiá de empresa y elegí con cuál operar.'
              buttonActionText='Sí, suscribir'
              buttonAction={redirectNewCompany}
              buttonCancel='Cancelar'
            />
          )}
          {onErrorMail && (
            <IBModalAction
              onClose={() => setOnErrorMail(false)}
              title='No podemos reenviar el email'
              textBody='Estamos trabajando para solucionarlo. Volvé a intentar más tarde.'
              buttonActionText='Entendido'
              buttonAction={() => setOnErrorMail(false)} 
              isOpen={onErrorMail}
              iconView='error'                
              />
          )}

        </>
    }</Box>)
}

export default DashboardPage
